<template>
	<div class="pcMaxW">
			<van-swipe class="swipeHome" :autoplay="5000" lazy-render>
			  <van-swipe-item v-for="(image,index) in banners" :key="index">
				  <div style="position: relative;">
					  <van-row>
						<van-col span="24">
							<img :src="image.icon" />
						</van-col>
						<!-- <van-col span="8" class="bgDark">
							<div class="p-5">
								<small class="textWhite50">{{ image.subTitle }}</small>
								<h3 class="my-4">{{ image.title }}</h3>
								<p class="fw-normal mb-4 textWhite50">{{ image.desc }}</p>
								<a href="#" :class="`btn btn-${image.color}`">Learn More</a>
							</div>
						</van-col> -->
					  </van-row>
						<div style="position: absolute;left: 0;top: 0;width: 100%;height: 100%;">
							<van-row>
								<van-col span="10">
								</van-col>
								<van-col span="14">
									<div class="header-text p-5">
										<h6 class="textWhite">{{ image.subTitle }}</h6>
										<h4>{{ image.title }}</h4>
										<a href="#" :class="`btn btn-${image.color}`">Browse Now</a>
									</div>
								</van-col>
							</van-row>
						</div>
			      </div>
			    </van-swipe-item>
			</van-swipe>
		<section class="pt-5">
			<div class="p-4 container bgDark" style="border-radius: 23px;">
				<div class="dFlex alCenter jcBetween title mb-3">
					<h5 class="m-0"><em>Most Popular</em> Right Now</h5>
					<!-- <a href="#" class="btn btn-sm btn-outline-light">VIEW MORE</a> -->
				</div>
				<van-row gutter="30">
				  <van-col class="imgItems mb-3" span="6" v-for="(image,index) in images" :key="index">
					  <div class="items">
					  <img :src="image.icon" />
					  <!-- <div :class="`textWhite bg-${image.color} textCenter p-1`">{{ image.subTitle }}</div> -->
						<div class="mt-4">
							<h6 class="mb-1 textWhite fonts">{{ image.title }}</h6>
							<p class="m-0 textWhite30 van-multi-ellipsis--l3 lh15">{{ image.desc }}</p>
						</div>
						</div>
					</van-col>
				</van-row>
			</div>
		</section>
	</div>
	
</template>

<script setup>
	import { ref,onMounted,getCurrentInstance } from 'vue'
	import { useI18n } from "vue-i18n"
	
	const { proxy } = getCurrentInstance();
	
	const active = ref(0);
	const total = ref(2);
	const banners = ref([
		{ icon : require('@/assets/images/hongkong_000.png'), color: 'primary',
			title: 'Browse Our Popular Games Here', 
			subTitle: 'Welcome To Pomelo', 
		}
	])
	const images = ref([
		{ icon : require('@/assets/images/1.png'), color: 'primary',
			title: '二次元卡牌遊戲《幻境召喚》',
			subTitle: '二次元卡牌遊戲', 
			desc: '《幻境召喚》是一款以二次元畫風為主題的卡牌策略手遊。玩家可以收集數百張風格各異的角色卡牌，組建專屬隊伍，挑戰各類副本與世界Boss。遊戲採用回合制戰鬥，策略性十足，還設有多種養成系統，讓你培養最強卡組。喜愛二次元和策略的玩家千萬不要錯過！' ,
		},
		{ icon : require('@/assets/images/2.png'), color: 'dark',
			title: '競技射擊遊戲《絕境突圍》', 
			subTitle: '競技射擊遊戲', 
			desc: '《絕境突圍》是一款快節奏的多人競技射擊遊戲。玩家將降落於一座封閉戰場中，透過拾取武器、裝備和補給品，與其他玩家展開生死對決。遊戲畫面逼真，操作手感流暢，多種地圖與模式任你選擇。挑戰自我極限，成為最後的生存者吧！' ,
		},
		{ icon : require('@/assets/images/3.png'), color: 'warning',
			title: '魔幻MMORPG《神域幻想》', 
			subTitle: '魔幻MMORPG', 
			desc: '《神域幻想》是一款融合魔幻元素的大型多人線上角色扮演遊戲。玩家將化身為來自不同種族的英雄，探索廣闊的神秘世界。遊戲內擁有豐富的主線劇情、多樣化的副本挑戰以及刺激的跨服戰場。自由交易系統和精美時裝更為角色增添個性。快來與好友一同冒險，創造屬於你的傳奇故事！' ,
		},
		{ icon : require('@/assets/images/4.png'), color: 'warning',
			title: '放置掛機遊戲《勇者遠征隊》', 
			subTitle: '放置掛機遊戲', 
			desc: '《勇者遠征隊》是一款輕鬆休閒的放置掛機遊戲，適合忙碌的現代玩家。即使離線，勇者們也會自動探索世界，收集資源與裝備。玩家只需定期上線強化角色、挑戰強敵、升級隊伍。遊戲畫風Q萌，玩法簡單易上手，是工作學習之餘放鬆心情的最佳選擇。' ,
		}
	])
	const isLoading = ref(false)
	
	onMounted(()=>{
		
	})
</script>

<style lang="less" scoped>
	.swipeHome{
		border-radius: 23px;
		.van-swipe-item{
			img{
				width: 100%;
			}
			p{
				line-height: 1.6;
			}
		}
		.header-text{
			text-align: right;margin-top: 6%;
			h6{
				font-size: 20px;
				color: #fff;
				font-weight: 400;
				margin-bottom: 25px;
			}
			h4{
				font-size: 45px;
				text-transform: uppercase;
				margin-bottom: 25px;
				font-weight: 700;
			}
		}
	}
	.pages {
	    position: absolute;
	    right: 15px;
	    bottom: 15px;
	    padding: 2px 5px;
		a{
			display: inline-flex;width: 35px;height: 35px;
			align-items: center;justify-content: center;font-size: 16px;
			background: rgba(0, 0, 0, 0.5);color: rgba(255,255,255,0.5);
			&.active{
				background: rgba(0, 0, 0, 1);color: rgba(255,255,255,1);
			}
		}
		a + a{
			margin-left: 0.25rem;
		}
	}
	.title{
		h5{
			font-size: 34px;
			text-decoration: none;
			margin-bottom: 30px;
			color: #e11e73;
			em{
				color: #fff;
				font-style: normal;
				text-decoration: underline;
			}
			
		}
	}
	.imgItems{
		.items{
			background-color: #27292a;
			    padding: 30px 15px;
			    border-radius: 23px;
			    // margin-bottom: 30px;
			.fonts{
				font-size: 15px;font-weight: 700;
			}
		}
		
		/deep/ img{
			width: 100%;vertical-align: middle;border-radius: 23px;
		}
		.lh15{
			line-height: 1.5;
		}
	}
</style>